import {
  CREATE_PROJECT_INVOICE_REQUEST,
  CREATE_PROJECT_INVOICE_ERROR,
  CREATE_PROJECT_INVOICE_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/createEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => (state = initialState, action) => {

  context.init(context);

  context.CREATE_ENTITY_REQUEST = CREATE_PROJECT_INVOICE_REQUEST;
  context.CREATE_ENTITY_ERROR = CREATE_PROJECT_INVOICE_ERROR;
  context.CREATE_ENTITY_SUCCESS = CREATE_PROJECT_INVOICE_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "projectInvoice";
  context.entityLocation = RESOURCES.ProjectInvoices;

  return context.execute(context)(entity)(state, action);
};